export * from './IconSettingsStroked';
